import { Mask, MaskWithStructures, RawMask, RawMaskWithStructures } from "@/types/mask";
import { mapRawToPcmVersion } from "./pcmVersion";
import { mapRawToStructure } from "./structure";

export const mapRawToMask = (raw: RawMask): Mask => {
  return {
    id: raw.id,
    name: raw.name,
    projectId: raw.project_id ?? null,
    waferDiameter: `${raw.wafer_diameter_in_mm}mm`,
    pcmVersion: mapRawToPcmVersion(raw.pcm_version),
    dieWidth: raw.die_width,
    dieHeight: raw.die_height,
    dieOffsetX: raw.die_offset_x,
    dieOffsetY: raw.die_offset_y,
    referenceDieX: raw.reference_die_x,
    referenceDieY: raw.reference_die_y,
    edgeIndent: raw.edge_indent,
  };
};

export const mapRawToMaskWithStructures = (raw: RawMaskWithStructures): MaskWithStructures => {
  return {
    id: raw.id,
    name: raw.name,
    projectId: raw.project_id ?? null,
    waferDiameter: `${raw.wafer_diameter_in_mm}mm`,
    pcmVersion: mapRawToPcmVersion(raw.pcm_version),
    structures: raw.structures.map(mapRawToStructure) ?? [],
    dieWidth: raw.die_width,
    dieHeight: raw.die_height,
    dieOffsetX: raw.die_offset_x,
    dieOffsetY: raw.die_offset_y,
    referenceDieX: raw.reference_die_x,
    referenceDieY: raw.reference_die_y,
    edgeIndent: raw.edge_indent,
  };
};
